<template>
    <div>
        <AboutUsTop />
        <!-- <div class="typeArea globalStrategy">
            <img src="@/assets/projectServices/globalStrategy0.png" />
            <img :src="imgSrc" class="locationSet" />
        </div> -->
        <div class="theArea typeArea">物流基地</div>
        <!--        <div class="theArea typeArea"></div>-->
        <div class="areaList typeArea">
            <!-- <div
                class="areaItem"
                v-for="(item, idx) in dataList"
                :key="idx"
                @mouseenter="showArea($event, item)"
                @mousemove="moveList"
                @mousedown="clickDescribe"
                @mouseup="upDescribe"
            > -->
            <div class="areaItem" v-for="(item, idx) in dataList" :key="idx">
                <div class="itemTitle">
                    <span class="activeSpan">{{ item.title }}</span>
                </div>
                <dl class="ulClass">
                    <dt
                        class="ulLi"
                        v-for="(iitem, i) in item.companyList"
                        :key="i"
                    >
                        {{ iitem }}
                    </dt>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import AboutUsTop from "@/components/AboutUsTop.vue";
import { getAction } from "@/api/services";
import imgOne from "@/assets/projectServices/globalStrategy1.png";
import imgTwo from "@/assets/projectServices/globalStrategy2.png";
import imgThree from "@/assets/projectServices/globalStrategy3.png";
import imgFour from "@/assets/projectServices/globalStrategy4.png";
import imgFive from "@/assets/projectServices/globalStrategy5.png";
import imgSix from "@/assets/projectServices/globalStrategy6.png";
export default {
    name: "GlobalStrategy",
    components: {
        AboutUsTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryServiceList",
            dataList: [],
            isClick: false,
            oldX: undefined,
            imgSrc: imgOne,
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        // clickDescribe(e) {
        //     this.isClick = true;
        //     this.oldX = e.clientX;
        // },
        // upDescribe() {
        //     this.isClick = false;
        //     this.endClick = true;
        // },
        // moveList(e) {
        //     if (this.isClick) {
        //         let nowX = e.clientX;
        //         let oldLeft = parseInt($(".areaItem").css("margin-left"));
        //         let moveX = oldLeft - this.oldX + nowX;
        //         let width =
        //             document.body.offsetWidth - this.dataList.length * 160;
        //         if (moveX < width || moveX > 0) {
        //             return;
        //         }
        //         if (nowX < this.oldX) {
        //             $(".areaItem")
        //                 .eq(0)
        //                 .css("margin-left", moveX + "px");
        //         } else {
        //             $(".areaItem")
        //                 .eq(0)
        //                 .css("margin-left", moveX + "px");
        //         }
        //         this.oldX = nowX;
        //     }
        // },
        // showArea(e, item) {
        //     if (!this.isClick) {
        //         switch (item.weight) {
        //             case 1:
        //                 this.imgSrc = imgOne;
        //                 break;
        //             case 2:
        //                 this.imgSrc = imgTwo;
        //                 break;
        //             case 3:
        //                 this.imgSrc = imgThree;
        //                 break;
        //             case 4:
        //                 this.imgSrc = imgFour;
        //                 break;
        //             case 5:
        //                 this.imgSrc = imgFive;
        //                 break;
        //             case 6:
        //                 this.imgSrc = imgSix;
        //                 break;
        //         }
        //         $(".itemTitle>span").removeClass("activeSpan");
        //         $(e.target).children().eq(0).children().addClass("activeSpan");
        //         $(".ulClass").addClass("ulNotActive");
        //         $(e.target).children().eq(1).removeClass("ulNotActive");
        //     }
        // },
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 70,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    that.dataList = res.result.records[0].cmsArticleList;
                    that.$nextTick(() => {
                        $(".itemTitle>span").removeClass("activeSpan");
                        $(".ulClass").addClass("ulNotActive");
                        $(".ulClass").eq(0).removeClass("ulNotActive");
                        $(".itemTitle").eq(0).children().addClass("activeSpan");
                    });
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.globalStrategy {
    width: 100%;
    margin-top: 124px;
    margin-bottom: 25px;
    position: relative;
    .locationSet {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }
    img {
        width: 100%;
    }
}
.theArea {
    margin-top: 40px;
    width: 100%;
    font-family: "优设标题黑";
    font-size: 32px;
    line-height: 28px;
    letter-spacing: 2px;
    color: #333333;
    padding-bottom: 44px;
    border-bottom: 1px solid #e1e1e1;
}
.areaList {
    display: flex;
    justify-content: space-between;
    margin-bottom: 100px;
    width: 100%;
    overflow: hidden;
    .areaItem {
        user-select: none;
        width: 100%;
        .itemTitle {
            font-size: 18px;
            letter-spacing: 1px;
            color: #333333;
            font-weight: 700;
            margin-bottom: 20px;
            text-align: center;
            span {
                padding-top: 15px;
                display: inline-block;
                border-top: 1px solid transparent;
            }
            .activeSpan {
                border-top: 1px solid #0052d9;
            }
        }
        .ulLi {
            min-width: 160px;
            width: 100%;
            font-size: 16px;
            text-align: center;
            color: #333333;
            font-weight: 400;
            line-height: 2em;
        }
        .ulNotActive {
            // opacity: 0;
        }
    }
}
</style>
